import { c as createCommonjsModule } from '../../common/_commonjsHelpers-eb5a497e.js';

var faBreadSlice = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'bread-slice';
var width = 576;
var height = 512;
var ligatures = [];
var unicode = 'f7ec';
var svgPathData = 'M288 0C108 0 0 93.4 0 169.14 0 199.44 24.24 224 64 224v256c0 17.67 16.12 32 36 32h376c19.88 0 36-14.33 36-32V224c39.76 0 64-24.56 64-54.86C576 93.4 468 0 288 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faBreadSlice = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
});

var faBreadSlice$1 = faBreadSlice.faBreadSlice;
export { faBreadSlice$1 as faBreadSlice };
